<template>
  <b-container fluid class="page-wrap">
    <b-row class="p-0 m-0 px-5 mx-5 px-md-5 pt-4 pt-md-5">
      <b-col lg="12" class="m-0 p-3 p-md-4 shell">

        <!-- Top bar -->
        <div class="topbar d-flex align-items-center justify-content-between flex-wrap">
          <div class="title-wrap text-center flex-fill">
            <div class="page-title">Банковские реквизиты Payton</div>
            <div class="page-sub">
              Воспользуйтесь банковскими реквизитами Payton.kz для пополнения баланса Вашего лицевого счета.
              Скопируйте необходимые данные для осуществления перевода в онлайн приложении Вашего банка
              либо распечатайте счет на оплату, предварительно указав сумму пополнения.
            </div>
          </div>
        </div>

        <!-- Main -->
        <b-row class="mt-4">
          <b-col lg="12">
            <!-- Everything inside printOut is printable -->
            <div id="printOut" class="glass-card">

              <!-- Header -->
              <div class="card-head d-flex align-items-start justify-content-between flex-wrap">
                <div>
                  <div class="card-title">Реквизиты для банковского перевода</div>
                  <div class="card-hint">
                    Скопируйте нужные поля для перевода.
                  </div>
                </div>

                <div class="badge-mini">
                  <b-icon icon="shield-check" class="mr-2"></b-icon>
                  Безопасный перевод
                </div>
              </div>

              <!-- Раньше здесь были селекты валюты/банка. Пока — read-only
                   поля с фиксированными значениями USD / Bereke Bank. -->
              <div class="no-print mt-3">
                <b-row>
                  <b-col md="6" class="mb-3">
                    <label class="field-label">Валюта</label>
                    <div class="dark-select readonly-field">{{ selectedCurrencyName }}</div>
                  </b-col>

                  <b-col md="6" class="mb-3">
                    <label class="field-label">Банк</label>
                    <div class="dark-select readonly-field">{{ bankNameText }}</div>
                  </b-col>
                </b-row>
              </div>

              <!-- Details -->
              <div class="kv-table mt-2">
                <!-- Bank name -->
                <div class="kv-row">
                  <div class="kv-k">Название банка</div>
                  <div class="kv-v">
                    <span class="kv-val">{{ bankNameText }}</span>
                    <b-button
                      size="sm"
                      class="copy-btn"
                      variant="outline-light"
                      @click="copyToClipboard(bankNameText)"
                      :disabled="!bankNameText || bankNameText === '---'"
                    >
                      <b-icon icon="clipboard" class="mr-1"></b-icon> Копировать
                    </b-button>
                  </div>
                </div>

                <!-- Account name -->
                <div class="kv-row">
                  <div class="kv-k">Имя счета</div>
                  <div class="kv-v">
                    <span class="kv-val">{{ accountNameText }}</span>
                    <b-button
                      size="sm"
                      class="copy-btn"
                      variant="outline-light"
                      @click="copyToClipboard(accountNameText)"
                      :disabled="!accountNameText || accountNameText === '---'"
                    >
                      <b-icon icon="clipboard" class="mr-1"></b-icon> Копировать
                    </b-button>
                  </div>
                </div>

                <!-- BIN -->
                <div class="kv-row">
                  <div class="kv-k">BIN Digital Galaxy</div>
                  <div class="kv-v">
                    <span class="kv-val">{{ binText }}</span>
                    <b-button
                      size="sm"
                      class="copy-btn"
                      variant="outline-light"
                      @click="copyToClipboard(binText)"
                      :disabled="!binText || binText === '---'"
                    >
                      <b-icon icon="clipboard" class="mr-1"></b-icon> Копировать
                    </b-button>
                  </div>
                </div>

                <!-- BIC -->
                <div class="kv-row">
                  <div class="kv-k">BIC</div>
                  <div class="kv-v">
                    <span class="kv-val">{{ bikText }}</span>
                    <b-button
                      size="sm"
                      class="copy-btn"
                      variant="outline-light"
                      @click="copyToClipboard(bikText)"
                      :disabled="!bikText || bikText === '---'"
                    >
                      <b-icon icon="clipboard" class="mr-1"></b-icon> Копировать
                    </b-button>
                  </div>
                </div>

                <!-- IBAN -->
                <div class="kv-row">
                  <div class="kv-k">Номер счета / IBAN</div>
                  <div class="kv-v">
                    <span class="kv-val mono">{{ ibanText }}</span>
                    <b-button
                      size="sm"
                      class="copy-btn"
                      variant="outline-light"
                      @click="copyToClipboard(ibanText)"
                      :disabled="!ibanText || ibanText === '---'"
                    >
                      <b-icon icon="clipboard" class="mr-1"></b-icon> Копировать
                    </b-button>
                  </div>
                </div>

                <!-- Branch -->
                <div class="kv-row">
                  <div class="kv-k">Филиал банка</div>
                  <div class="kv-v">
                    <span class="kv-val">{{ branchText }}</span>
                    <b-button
                      size="sm"
                      class="copy-btn"
                      variant="outline-light"
                      @click="copyToClipboard(branchText)"
                    >
                      <b-icon icon="clipboard" class="mr-1"></b-icon> Копировать
                    </b-button>
                  </div>
                </div>

                <!-- Payment purpose code -->
                <div class="kv-row">
                  <div class="kv-k">Код назначения платежа</div>
                  <div class="kv-v">
                    <div class="kv-val">
                      <div class="mono big">371</div>
                      <div class="small">
                        Покупка цифровых активов, включая перевод денег на банковский счет обмена цифровых активов
                      </div>
                    </div>
                    <b-button
                      size="sm"
                      class="copy-btn"
                      variant="outline-light"
                      @click="copyToClipboard('371')"
                    >
                      <b-icon icon="clipboard" class="mr-1"></b-icon> Копировать
                    </b-button>
                  </div>
                </div>

                <!-- KBe -->
                <div class="kv-row">
                  <div class="kv-k">КБе</div>
                  <div class="kv-v">
                    <div class="kv-val">
                      <div class="mono big">17</div>
                      <div class="small">Резиденты Республики Казахстан. Юридические лица.</div>
                    </div>
                    <b-button
                      size="sm"
                      class="copy-btn"
                      variant="outline-light"
                      @click="copyToClipboard('17')"
                    >
                      <b-icon icon="clipboard" class="mr-1"></b-icon> Копировать
                    </b-button>
                  </div>
                </div>

                <!-- User ID -->
                <div class="kv-row">
                  <div class="kv-k">Ваш идентификационный код</div>
                  <div class="kv-v align-start">
                    <div class="w-100">
                      <div class="d-flex align-items-center justify-content-between flex-wrap">
                        <div class="kv-val mono">{{ userIdText || '---' }}</div>
                        <b-button
                          size="sm"
                          class="copy-btn"
                          variant="outline-light"
                          @click="copyToClipboard(userIdText)"
                          :disabled="!userIdText"
                        >
                          <b-icon icon="clipboard" class="mr-1"></b-icon> Копировать
                        </b-button>
                      </div>

                      <div class="warn mt-2">
                        Укажите этот идентификационный код в качестве примечания при осуществлении банковского перевода.
                        Для нерезидентов это примечание также является обязательным.
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Amount -->
                <div class="kv-row">
                  <div class="kv-k">Сумма</div>
                  <div class="kv-v">
                    <div class="amount-wrap">
                      <input
                        v-model="amount"
                        type="text"
                        class="amount-input"
                        placeholder="0.00"
                      />
                      <span class="amount-cur">{{ selectedCurrencyName }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Actions -->
              <div class="no-print mt-4 d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-between">
                <div class="mini-help mb-3 mb-md-0">
                  <b-icon icon="info-circle" class="mr-2"></b-icon>
                  Нажмите «Распечатать / скачать».
                </div>

                <div class="d-flex gap-10">
                  <b-button
                    variant="outline-light"
                    class="btn-soft"
                    @click="clearForm"
                  >
                    <b-icon icon="x-circle" class="mr-2"></b-icon>
                    Очистить
                  </b-button>

                  <b-button
                    variant="success"
                    class="btn-primary2"
                    :disabled="!canPrint"
                    @click="printNow"
                  >
                    <b-icon icon="download" class="mr-2"></b-icon>
                    Распечатать / скачать
                  </b-button>
                </div>
              </div>

            </div>
          </b-col>
        </b-row>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { apiDomain, getHeader } from '@/config/config'

export default {
  name: 'BankInfo2',
  data() {
    return {
      // selections
      selectedBankId: null,
      selectedCurrencyId: 1, // default USD

      // data
      banks: [],
      currencies: [
        { id: 1, name: 'USD' }
      ],

      // input
      amount: ''
    }
  },

  computed: {
    ...mapState(['loginedUser']),

    userIdText() {
      return this.loginedUser && this.loginedUser.id ? String(this.loginedUser.id) : ''
    },

    selectedCurrencyName() {
      var c = this.getCurrencyById(this.selectedCurrencyId)
      return c ? c.name : 'USD'
    },

    currencyOptions() {
      return this.currencies.map(function (c) {
        return { value: c.id, text: c.name }
      })
    },

    // Показываем только Bereke Bank — остальные банки скрыты из выбора.
    visibleBanks() {
      return this.banks.filter(function (b) {
        return String(b.bankName || '').toLowerCase().indexOf('bereke') !== -1
      })
    },
    bankOptions() {
      var opts = [{ value: null, text: 'Выберите банк' }]
      var list = this.visibleBanks
      for (var i = 0; i < list.length; i++) {
        var b = list[i]
        opts.push({ value: b.bankId, text: b.bankName })
      }
      return opts
    },

    selectedBank() {
      if (!this.selectedBankId) return null
      for (var i = 0; i < this.banks.length; i++) {
        if (this.banks[i].bankId === this.selectedBankId) return this.banks[i]
      }
      return null
    },

    // Реквизиты счёта Bereke Bank (USD) — по официальному письму банка.
    // В номере счёта последние 6 символов заменены на CLIENT.
    bankNameText() {
      return 'AO Bereke Bank'
    },
    accountNameText() {
      return 'ЧК Digital Galaxy Ltd.'
    },
    binText() {
      return '241140900517'
    },
    bikText() {
      return 'BRKEKZKA'
    },
    ibanText() {
      return 'KZ39914012203UCLIENT'
    },
    branchText() {
      return 'Филиал АО Bereke Bank в г.Астана'
    },

    canPrint() {
      // Реквизиты фиксированы (Bereke USD) — достаточно указанной суммы.
      return this.parseAmount(this.amount) > 0
    }
  },

  methods: {
    goBack() {
      this.$router.back()
    },

    getCurrencyById(id) {
      for (var i = 0; i < this.currencies.length; i++) {
        if (this.currencies[i].id === id) return this.currencies[i]
      }
      return null
    },

    parseAmount(val) {
      if (!val && val !== 0) return 0
      // allow "1 000,50" or "1000.50"
      var s = String(val).trim().replace(/\s+/g, '').replace(',', '.')
      var n = parseFloat(s)
      return isNaN(n) ? 0 : n
    },

    clearForm() {
      this.selectedBankId = null
      this.amount = ''
      this.toast('Форма очищена.', 'Готово', 'info')
    },

    copyToClipboard(text) {
      var value = text ? String(text) : ''
      if (!value || value === '---') {
        this.toast('Нечего копировать.', 'Внимание', 'warning')
        return
      }

      // Clipboard API
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(
          () => this.toast('Скопировано в буфер обмена.', 'Готово', 'success'),
          () => this.fallbackCopy(value)
        )
        return
      }

      this.fallbackCopy(value)
    },

    fallbackCopy(value) {
      try {
        var el = document.createElement('textarea')
        el.value = value
        el.setAttribute('readonly', '')
        el.style.position = 'absolute'
        el.style.left = '-9999px'
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        this.toast('Скопировано в буфер обмена.', 'Готово', 'success')
      } catch (e) {
        this.toast('Не удалось скопировать. Скопируйте вручную.', 'Ошибка', 'danger')
      }
    },

    toast(message, title, variant) {
      if (this.$bvToast) {
        this.$bvToast.toast(message, {
          title: title || 'Сообщение',
          variant: variant || 'info',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 2600
        })
      }
    },

    printNow() {
      // Print first (so user can save PDF), then create tx
      window.print()
      this.createTransaction()
    },

    createTransaction() {
      if (!this.canPrint) {
        this.toast('Заполните банк и сумму (больше 0).', 'Внимание', 'warning')
        return
      }

      var payload = {
        bankId: this.selectedBankId,
        userId: this.loginedUser && this.loginedUser.id ? this.loginedUser.id : null,
        amount: this.parseAmount(this.amount),
        currency: this.selectedCurrencyName,
        txStatus: 'PENDING'
      }

      axios
        .post(apiDomain + '/exchange/transaction/create', payload, { headers: getHeader() })
        .then(() => {})
        .catch((err) => {
          console.error('Error creating transaction:', err)
          this.toast('Ошибка при создании транзакции. Попробуйте позже.', 'Ошибка', 'danger')
        })
    },

    getBanks() {
      axios
        .get(apiDomain + '/exchange/bank/list', { headers: getHeader() })
        .then((res) => {
          this.banks = Array.isArray(res.data) ? res.data : []

          // auto-select первый видимый (Bereke) банк
          if (!this.selectedBankId && this.visibleBanks.length > 0) {
            this.selectedBankId = this.visibleBanks[0].bankId
          }
        })
        .catch((err) => {
          console.error('Error fetching banks:', err)
          this.toast('Не удалось загрузить список банков.', 'Ошибка', 'danger')
        })
    }
  },

  created() {
    this.getBanks()
  }
}
</script>

<style scoped>
/* ===== Page background (dark) ===== */
.page-wrap{
  min-height: 100vh;
 
}

/* Outer shell card */
.shell{
  border-radius: 18px;
  background: rgba(17, 24, 39, 0.55);
  border: 1px solid rgba(255,255,255,0.06);
  box-shadow: 0 24px 80px rgba(0,0,0,0.35);
}

/* Topbar */
.topbar{
  padding: 14px 14px;
  border-radius: 16px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.06);
}

.back-wrap{
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.07);
  transition: .15s ease;
}
.back-wrap:hover{ transform: translateY(-1px); background: rgba(255,255,255,0.05); }
.back-text{
  font-weight: 800;
  color: #d7dbe7;
  letter-spacing: .2px;
}
.back-ico{ display:flex; }

.title-wrap{
  padding: 8px 14px;
}
.page-title{
  font-weight: 900;
  color: #f3f4f6;
  letter-spacing: .2px;
  font-size: 18px;
}
.page-sub{
  color: rgba(229,231,235,0.75);
  font-size: 12px;
  margin-top: 4px;
}
.ghost-spacer{ width: 90px; }

/* Glass card */
.glass-card{
  border-radius: 18px;
  padding: 18px;
  background: linear-gradient(135deg, rgba(255,255,255,0.07), rgba(255,255,255,0.03));
  border: 1px solid rgba(255,255,255,0.08);
  box-shadow: 0 18px 60px rgba(0,0,0,0.35);
}

/* Head */
.card-head{
  gap: 12px;
}
.card-title{
  font-weight: 900;
  color: #f3f4f6;
  letter-spacing: .2px;
  font-size: 16px;
}
.card-hint{
  color: rgba(229,231,235,0.75);
  font-size: 12px;
  margin-top: 4px;
}
.badge-mini{
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(99,102,241,0.10);
  border: 1px solid rgba(99,102,241,0.25);
  color: #dbeafe;
  font-weight: 800;
  font-size: 12px;
}

/* Inputs */
.field-label{
  color: rgba(229,231,235,0.70);
  font-weight: 800;
  font-size: 12px;
  margin-bottom: 8px;
}
.dark-select{
  border-radius: 14px !important;
  background: rgba(0,0,0,0.28) !important;
  border: 1px solid rgba(255,255,255,0.10) !important;
  color: #e5e7eb !important;
}
.dark-select:focus{
  box-shadow: 0 0 0 5px rgba(99,102,241,0.22) !important;
  border-color: rgba(99,102,241,0.55) !important;
}
.readonly-field{
  padding: 0.5rem 0.9rem;
  display: flex;
  align-items: center;
  min-height: 44px;
  font-weight: 600;
}

/* Key-value table */
.kv-table{
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(0,0,0,0.18);
}
.kv-row{
  display: flex;
  gap: 12px;
  padding: 14px 14px;
  align-items: center;
  border-top: 1px solid rgba(255,255,255,0.06);
}
.kv-row:first-child{ border-top: 0; }
.kv-k{
  width: 42%;
  color: rgba(229,231,235,0.70);
  font-weight: 900;
  font-size: 12px;
  letter-spacing: .3px;
}
.kv-v{
  width: 58%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.kv-v.align-start{ align-items: flex-start; }
.kv-val{
  color: #f3f4f6;
  font-weight: 800;
  font-size: 13px;
}
.kv-val .small{
  color: rgba(229,231,235,0.75);
  font-size: 12px;
  font-weight: 700;
  margin-top: 4px;
  line-height: 1.35;
}
.mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.big{
  font-size: 16px;
  font-weight: 900;
}

/* Copy button */
.copy-btn{
  border-radius: 14px !important;
  font-weight: 900 !important;
  padding: 8px 12px !important;
  border: 1px solid rgba(255,255,255,0.16) !important;
  background: rgba(255,255,255,0.03) !important;
}
.copy-btn:hover{
  background: rgba(255,255,255,0.06) !important;
  transform: translateY(-1px);
}

/* Amount */
.amount-wrap{
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
}
.amount-input{
  width: 220px;
  border-radius: 14px;
  padding: 10px 12px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(0,0,0,0.25);
  color: #f3f4f6;
  font-weight: 900;
  outline: none;
}
.amount-input:focus{
  border-color: rgba(99,102,241,0.55);
  box-shadow: 0 0 0 5px rgba(99,102,241,0.22);
}
.amount-cur{
  color: rgba(229,231,235,0.75);
  font-weight: 900;
  font-size: 12px;
  padding: 8px 10px;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.03);
}

/* Bottom help */
.mini-help{
  color: rgba(229,231,235,0.75);
  font-size: 12px;
  font-weight: 700;
}
.pill{
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  background: rgba(251, 191, 36, 0.16);
  border: 1px solid rgba(251, 191, 36, 0.28);
  color: #fde68a;
  font-weight: 900;
  margin: 0 2px;
}

.gap-10{ gap: 10px; }

/* Buttons */
.btn-soft{
  border-radius: 16px !important;
  font-weight: 900 !important;
  border: 1px solid rgba(255,255,255,0.16) !important;
  background: rgba(255,255,255,0.03) !important;
}
.btn-soft:hover{ background: rgba(255,255,255,0.06) !important; transform: translateY(-1px); }

.btn-primary2{
  border-radius: 16px !important;
  font-weight: 900 !important;
  box-shadow: 0 18px 40px rgba(34,197,94,0.18);
}

/* Warning note */
.warn{
  color: rgba(251, 113, 133, 0.95);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.35;
  background: rgba(239,68,68,0.08);
  border: 1px solid rgba(239,68,68,0.18);
  padding: 10px 12px;
  border-radius: 14px;
}

/* Responsive */
@media (max-width: 768px){
  .kv-row{ flex-direction: column; align-items: flex-start; }
  .kv-k{ width: 100%; }
  .kv-v{ width: 100%; }
  .amount-input{ width: 100%; }
  .amount-wrap{ justify-content: flex-start; }
}

/* ===== Print only #printOut ===== */
@media print {
  body * { visibility: hidden; }
  #printOut, #printOut * { visibility: visible; }

  #printOut {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background: #ffffff !important;
    border: 1px solid #ddd !important;
    box-shadow: none !important;
  }

  .no-print { display: none !important; }

  #printOut, #printOut * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  /* Convert dark text to readable in print */
  .card-title, .kv-val, .mono, .big { color: #111827 !important; }
  .kv-k, .card-hint { color: #374151 !important; }
  .kv-table { background: #fff !important; border-color: #ddd !important; }
  .kv-row { border-top-color: #e5e7eb !important; }
  .warn { color: #991b1b !important; background: #fff5f5 !important; border-color: #fecaca !important; }
}
</style>
